module.exports = __webpack_public_path__ + "static/media/ils_covid_failed_myway.c492f18d.svg";